import React, { ChangeEvent, Component } from "react";
import IGetCatalogItemsDTO from "../../../../models/DTO/IGetCatalogItemsDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IOnGetCatalogItemsDTO from "../../../../models/DTO/IOnGetCatalogItemsDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import IOnUpdateSpiffGroupItemsDTO from "../../../../models/DTO/IOnUpdateSpiffGroupItemsDTO";
import IOnUpdateSpiffGroupUsersDTO from "../../../../models/DTO/IOnUpdateSpiffGroupUsersDTO";
import ITypeaheadLookupByTokenTypeDTO from "../../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import IUpdateSpiffGroupItemsDTO from "../../../../models/DTO/IUpdateSpiffGroupItemsDTO";
import IUpdateSpiffGroupUsersDTO from "../../../../models/DTO/IUpdateSpiffGroupUsersDTO";
import ICatalog from "../../../../models/ICatalog";
import ICatalog_Item from "../../../../models/ICatalog_Item";
import IConnection_Token from "../../../../models/IConnection_Token";
import IConnection_TokenUI from "../../../../models/IConnection_TokenUI";
import ISpiff from "../../../../models/ISpiff";
import ISpiff_Group from "../../../../models/ISpiff_Group";
import ISpiff_Group_User_Map from "../../../../models/ISpiff_Group_User_Map";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUser from "../../../../models/IUser";
import IUserUI from "../../../../models/IUserUI";
import TokenTypesEnum from "../../../../models/TokenTypesEnum";
import ChevronToggle from "../../../shared/ChevronToggle/ChevronToggle";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import moment from "moment";
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    spiffGroup: ISpiff_Group;
    index: number;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    editGroupSidebarFn: (existingSpiffGroup?: ISpiff_Group) => void;
};

type State = {
    chevronOpen: boolean;
    catalogGuid?: string;
    catalogs?: ICatalog[];
    usersFound?: IConnection_Token[];
    catalogItemsFound?: ICatalog_Item[];
    selectedCatalogItem?: ICatalog_Item;
    selectedUser?: IUser;
    fixed_amount: string;
    percent: string;
    subViewReady: boolean;
    subView: any | null;
    clearCatalogItemsFound: boolean;
};

class SpiffGroupRow extends Component<Props, State> {
    readonly state: State = {
        chevronOpen: this.props.index === 0,
        fixed_amount: "",
        percent: "",
        subViewReady: false,
        subView: null,
        clearCatalogItemsFound: false,
    };

    componentDidMount(): void {
        this.props.socket.on("onTypeaheadLookupByTokenType", this.onTypeaheadLookupByTokenType);
        this.props.socket.on("onGetCatalogItems", this.onGetCatalogItems);
        this.props.socket.on("onGetCatalogs", this.onGetCatalogs);
        this.props.socket.on("onUpdateSpiffGroupUsers", this.onUpdateSpiffGroupUsers);
        this.props.socket.on("onUpdateSpiffGroupItems", this.onUpdateSpiffGroupItems);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onTypeaheadLookupByTokenType", this.onTypeaheadLookupByTokenType);
        this.props.socket.removeListener("onGetCatalogItems", this.onGetCatalogItems);
        this.props.socket.removeListener("onGetCatalogs", this.onGetCatalogs);
        this.props.socket.removeListener("onUpdateSpiffGroupUsers", this.onUpdateSpiffGroupUsers);
        this.props.socket.removeListener("onUpdateSpiffGroupItems", this.onUpdateSpiffGroupItems);
    }

    toggleChevron = () => {
        this.setState({
            chevronOpen: !this.state.chevronOpen,
        });
    };

    addUser = () => {
        if (!this.state.selectedUser) {
            return;
        }

        const payload: IUpdateSpiffGroupUsersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            spiffGroupGuid: this.props.spiffGroup.guid,
            spiffGroupUsers: [
                {
                    spiff_group_id: this.props.spiffGroup.id,
                    user_id: this.state.selectedUser.id,
                },
            ],
        };

        this.props.socket.emit("updateSpiffGroupUsers", payload);
    };

    onUpdateSpiffGroupUsers = (data: IOnUpdateSpiffGroupUsersDTO) => {
        this.setState({
            selectedUser: undefined,
        });
    };

    onUpdateSpiffGroupItems = (data: IOnUpdateSpiffGroupItemsDTO) => {
        this.setState({
            selectedCatalogItem: undefined,
            clearCatalogItemsFound: true,
            fixed_amount: "",
        });
    };

    lookupUser = (typeahead: string) => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            tokenType: TokenTypesEnum.VENDOR_USER,
            supplierGuid: this.props.supplierModel.guid,
            name: typeahead,
        };

        this.props.socket.emit("typeaheadLookupByTokenType", payload);
    };

    onTypeaheadLookupByTokenType = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        console.log("onTypeaheadLookupByTokenType", data);
        this.setState({
            usersFound: data.results,
        });
    };

    lookupCatalogItem = (item_name: string) => {
        if (!this.state.catalogGuid) {
            return;
        }

        const payload: IGetCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
            queryString: `?item_name=${item_name}`,
        };

        this.props.socket.emit("getCatalogItems", payload);
    };

    onGetCatalogItems = (data: IOnGetCatalogItemsDTO) => {
        // console.log('onGetCatalogItems', data);
        this.setState({
            catalogItemsFound: data.catalog_items,
        });
    };

    addCatalogItem = () => {
        if (!this.state.percent || (!this.props.spiffGroup.is_global_spiff ? !this.state.selectedCatalogItem : false)) {
            return;
        }

        const payload: IUpdateSpiffGroupItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            spiffGroupItems: [],
            spiffGroupGuid: this.props.spiffGroup.guid,
        };

        const spiffGroupItems = { percent: Number(this.state.percent) };

        if (this.state.selectedCatalogItem) {
            // @ts-expect-error
            spiffGroupItems["catalog_item_id"] = this.state.selectedCatalogItem.id;
        }

        const selectedCatalog = _.find(this.state.catalogs, (catalog) => {
            if (catalog.guid === this.state.catalogGuid) {
                return catalog;
            }
        });

        // @ts-expect-error
        spiffGroupItems["catalog_id"] = selectedCatalog ? selectedCatalog.id : null;

        payload.spiffGroupItems.push(spiffGroupItems);

        this.props.socket.emit("updateSpiffGroupItems", payload);
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit("getCatalogs", payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        console.log("onGetCatalogs: ", data);

        this.setState({ catalogs: data.catalogs });
    };

    handleChange = (e: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const value = e.target.value;
        const name = e.target.name;

        // @ts-expect-error
        this.setState({ [name]: value });
    };

    selectCatalogItem = (catalogItem: ICatalog_Item) => {
        this.setState({
            selectedCatalogItem: catalogItem,
        });
    };

    selectUser = (userToken: IConnection_TokenUI) => {
        console.log("selectUser", userToken);
        this.setState({
            selectedUser: userToken.User,
        });
    };

    isCatalogItemAddDisabled = (): boolean => {
        let hasProperCatalogItemsSet = false;

        if (this.props.spiffGroup.is_global_spiff) {
            hasProperCatalogItemsSet = true;
        } else {
            hasProperCatalogItemsSet = !!this.state.selectedCatalogItem;
        }

        if (this.state.catalogGuid && hasProperCatalogItemsSet && this.state.percent) {
            return false;
        } else {
            return true;
        }
    };

    clearCatalogItemsFoundCallback = () => {
        this.setState({
            clearCatalogItemsFound: false,
        });
    };

    deleteSpiffUser = (spiffUserDetail: any) => {
        const spiffUser = spiffUserDetail.Spiff_Group_User_Map;

        spiffUser.deleteFlag = true;

        const payload: IUpdateSpiffGroupUsersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            spiffGroupGuid: this.props.spiffGroup.guid,
            spiffGroupUsers: [spiffUser],
        };

        this.props.socket.emit("updateSpiffGroupUsers", payload);
    };

    deleteSpiffCatalogItem = (spiff: ISpiff) => {
        spiff.deleteFlag = true;

        const payload: IUpdateSpiffGroupItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            spiffGroupGuid: this.props.spiffGroup.guid,
            spiffGroupItems: [spiff],
        };

        this.props.socket.emit("updateSpiffGroupItems", payload);
    };

    getUsersRow = () => {
        return (
            <div>
                <div>
                    <OwTitle title={"users"} tag={"h6"} leftIconName={"fad fa-users"} />
                </div>
                <div className={"row"}>
                    <div className={"col-3"}>
                        <Typeahead
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={this.lookupUser}
                            typeaheadItems={this.state.usersFound}
                            titleProp={"User.name"}
                            subTitleProp={"User.email"}
                            outerWrapperClassName={"w-100"}
                            selectedItemFn={this.selectUser}
                            selectedItem={this.state.selectedUser}
                            selectedItemTitleProp={"name"}
                        />
                    </div>
                    <div className={"col"}>
                        <OwButton title={"add"} leftIconClass={"fas fa-plus"} fn={this.addUser} />
                    </div>
                </div>
                <table className={"table table-dark table-striped mt-2"} style={{ backgroundColor: "unset" }}>
                    <tbody>
                        <tr>
                            <td className={"w-3r"}></td>
                            <td className={"w-15r"}>
                                <OwLabel title={"name"} />
                            </td>
                            <td>
                                <OwLabel title={"email"} />
                            </td>
                        </tr>
                    </tbody>
                    {this.props.spiffGroup.Users.length
                        ? this.props.spiffGroup.Users.map((user) => {
                              return (
                                  <tbody key={user.guid}>
                                      <tr>
                                          <td>
                                              <i
                                                  className={"fad fa-trash-alt text-danger pointer"}
                                                  onClick={(e: any) => {
                                                      this.deleteSpiffUser(user);
                                                  }}></i>
                                          </td>
                                          <td>{user.name}</td>
                                          <td>{user.email}</td>
                                      </tr>
                                  </tbody>
                              );
                          })
                        : null}
                </table>
            </div>
        );
    };

    getCatalogDetailRow = () => {
        return (
            <div>
                <div className={"row"}>
                    <div className={"flex-column col-auto"}>
                        <div className={""}>
                            <OwTitle title={"catalog"} tag={"h6"} leftIconName={"fad fa-book"} />
                        </div>
                        <div>
                            <div className={""}>
                                <OwSelectOption
                                    options={this.state.catalogs}
                                    titleProp={"name"}
                                    valueProp={"guid"}
                                    fn={this.handleChange}
                                    name={"catalogGuid"}
                                    selectedOption={this.state}
                                    selectedOptionProp={"catalogGuid"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col flex-column"}>
                        <div className={"row"}>
                            <div className={"col-3 .g-0"}>
                                <div>
                                    <OwTitle title={"catalog_items"} tag={"h6"} leftIconName={"fad fa-books"} />
                                </div>
                                <Typeahead
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    selectedItem={this.state.selectedCatalogItem}
                                    selectedItemFn={this.selectCatalogItem}
                                    typeaheadApiFn={this.lookupCatalogItem}
                                    titleProp={"name"}
                                    subTitleProp={"sku"}
                                    typeaheadItems={this.state.catalogItemsFound}
                                    clearTypeahead={this.state.clearCatalogItemsFound}
                                    clearTypeaheadCallback={this.clearCatalogItemsFoundCallback}
                                />
                            </div>
                            <div className={"col-1"}>
                                <div>
                                    <OwTitle title={"percent"} tag={"h6"} />
                                </div>
                                <OwInputWrapper name={"percent"} fn={this.handleChange} value={this.state.percent} />
                            </div>
                            <div className={""}>
                                <div>
                                    <OwTitle title={""} disableTranslation={true} leftIconName={"fa fa-hidden"} tag={"h6"} />
                                </div>
                                <OwButton
                                    title={"add"}
                                    leftIconClass={"fas fa-plus"}
                                    fn={this.addCatalogItem}
                                    disabled={this.isCatalogItemAddDisabled()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <table className={"table table-dark mt-2"} style={{ backgroundColor: "unset" }}>
                    <tbody>
                        <tr>
                            <td className={"w-3r"}></td>
                            <td className={"w-15r"}>
                                <OwLabel title={"catalog"} />
                            </td>
                            <td className={"w-20r"}>
                                <OwLabel title={"item"} />
                            </td>
                            <td>
                                <OwLabel title={"percent"} />
                            </td>
                        </tr>
                    </tbody>
                    {this.props.spiffGroup.Spiffs.length
                        ? this.props.spiffGroup.Spiffs.map((spiff) => {
                              return (
                                  <tbody key={spiff.guid}>
                                      <tr>
                                          <td>
                                              <i
                                                  className={"fad fa-trash-alt text-danger pointer"}
                                                  onClick={(e: any) => {
                                                      this.deleteSpiffCatalogItem(spiff);
                                                  }}></i>{" "}
                                          </td>
                                          <td>{spiff.Catalog ? spiff.Catalog.name : ""}</td>
                                          <td>
                                              {spiff.Catalog_Item && spiff.Catalog_Item ? (
                                                  spiff.Catalog_Item.name
                                              ) : (
                                                  <OwLabel title={"all"} isUppercase={true} />
                                              )}
                                          </td>
                                          <td>{spiff.percent}%</td>
                                      </tr>
                                  </tbody>
                              );
                          })
                        : null}
                </table>
            </div>
        );
    };

    getSubview = () => {
        return (
            <div>
                {this.getUsersRow()}
                {this.getCatalogDetailRow()}
            </div>
        );
    };

    render() {
        const totalColumns = 2;

        const spiffStartDate = moment(this.props.spiffGroup.min_date).format("MM/DD/YYYY");
        const spiffEndDate = moment(this.props.spiffGroup.max_date).format("MM/DD/YYYY");

        return (
            <tbody>
                <tr className="SpiffGroupRow">
                    <td className={"w-5r"}>
                        <ChevronToggle className={""} toggleFn={this.toggleChevron} isVisible={this.state.chevronOpen} />
                    </td>
                    <td>
                        <h5 className={"d-flex"}>
                            <div>
                                <i
                                    className={"fad fa-pencil text-primary pointer me-2"}
                                    onClick={() => {
                                        this.props.editGroupSidebarFn(this.props.spiffGroup);
                                    }}
                                />
                                <div className={"text-start d-inline-flex flex-column"}>
                                    {this.props.spiffGroup.name}
                                    <br />
                                    <span className={"text-small text-muted"}>
                                        {spiffStartDate} - {spiffEndDate}
                                    </span>
                                </div>
                            </div>

                            <div className={"text-end ms-auto"}>
                                {this.props.spiffGroup.is_global_spiff ? (
                                    <OwLabel
                                        className={"text-warning me-2"}
                                        leftIconClass={"fad fa-globe"}
                                        title={"global"}
                                        isUppercase={true}
                                    />
                                ) : null}
                            </div>
                        </h5>
                    </td>
                </tr>
                {this.state.chevronOpen ? (
                    <React.Fragment>
                        <tr>
                            <td colSpan={totalColumns}>{this.getSubview()}</td>
                        </tr>
                    </React.Fragment>
                ) : null}
            </tbody>
        );
    }
}

export default SpiffGroupRow;
